<i18n lang='yml' src='../i18n/ContainerTrainingAgreementForm.yml'></i18n>
<template>
  <div>
    <h4 class="heading-block">{{ $t('manage_candidates') }}</h4>
    <h5 class="heading-page">{{method === 'new' ? $t('create_candidate_membership') : $t('manage_training_agreement')}}</h5>
    <p class="border-bottom">{{method === 'new' ? $t('find_candidate') : $t('manage_candidate_agreement')}}</p>
    <flash :message_type="message_type" :message_text="message_text"/>
    <Form ref="observer" v-slot="{  errors }" @submit="submitCTA" @invalid-submit="setErrorMessage">
      <input ref="csrfTokenField" v-model="csrfToken" type="hidden" name="authenticity_token">
      <div v-if="method === 'new'" class="form-group">
        <div class="row">
          <div class="col-12 col-md-8 col-lg-6">
            <label for='candidate'>{{ $t('candidate') }}</label>
            <Field 
              :name="$t('candidate')"  
              rules="required"
              v-slot="{ errors, field }"
              v-model="trainingAgreement" 
              >
              <multi-select 
                :options="dropDownAgreements" 
                :searchable="true" 
                class="single-select"
                @search-change="onTextEntry"
                v-bind="field"
                label="label" 
                :internal-search="false" 
                :loading="loading"
                :class="{'is-invalid': errors[0]}" 
                key="value"  
              />
              <div class="invalid-feedback" id="time_allowance_error" v-if="errors[0]">
                <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                <span>{{ errors[0] }}</span> 
              </div>
            </Field>  
          </div>   
          <div class="col-12"> 
            <h5 class="heading-page">{{$t('manage_training_agreement')}}</h5>
            <p class="border-bottom">{{ $t('manage_candidate_agreement')}}</p>
          </div>
        </div> 
      </div>
     
      <div v-if="trainingAgreement || containerTrainingAgreement.training_agreement_id">
        <div class="form-group" v-if="method === 'edit'">
          <label class="m-0" for="candidate_name">{{$t('candidate')}}</label>
          <span class="form-control-plaintext p-0" id="candidate_name">{{containerTrainingAgreement.user_identity}}</span>
        </div>
        <div class="form-group">
          <label class="m-0" for="organization">{{$t('organization')}}</label>
          <span class="form-control-plaintext p-0" id="organization">{{container_name}}</span>
        </div>
        <div class="form-group">
          <label class="m-0" for="trade">{{$t('trade')}}</label>
          <span class="form-control-plaintext p-0" id="trade">{{trainingAgreement ? trainingAgreement.training_program : containerTrainingAgreement.training_program_name}}</span>
        </div>
        <div class="form-group">
          <label class="m-0" for="date">{{$t('date_init')}}</label>
          <span class="form-control-plaintext p-0" id="date">{{formatDate(containerTrainingAgreement.created_at)}}</span>
        </div>
        <div class="form-group">
          <label class="m-0" for="confirmed_hours">{{$t('confirmed_hours')}}</label>
          <span class="form-control-plaintext p-0" id="confirmed_hours">{{containerTrainingAgreement.confirmed_hours.toFixed(2)}}</span>        
        </div>
        <hr/>
      </div>
      <fieldset class="border-bottom">
        <div v-if="trainingAgreement || containerTrainingAgreement.training_agreement_id">
          <div class="form-group" v-if="method === 'edit'">
            <label class="m-0" for="candidate_name">{{$t('candidate')}}</label>
            <span class="form-control-plaintext p-0" id="candidate_name">{{containerTrainingAgreement.user_identity}}</span>
          </div>
          <div class="form-group">
            <label class="m-0" for="organization">{{$t('organization')}}</label>
            <span class="form-control-plaintext p-0" id="organization">{{container_name}}</span>
          </div>
          <div class="form-group">
            <label class="m-0" for="trade">{{$t('trade')}}</label>
            <span class="form-control-plaintext p-0" id="trade">{{trainingAgreement ? trainingAgreement.training_program : containerTrainingAgreement.training_program_name}}</span>
          </div>
          <div class="form-group">
            <label class="m-0" for="date">{{$t('date_init')}}</label>
            <span class="form-control-plaintext p-0" id="date">{{formatDate(containerTrainingAgreement.created_at)}}</span>
          </div>
          <div class="form-group">
            <label class="m-0" for="confirmed_hours">{{$t('confirmed_hours')}}</label>
            <span class="form-control-plaintext p-0" id="confirmed_hours">{{containerTrainingAgreement.confirmed_hours.toFixed(2)}}</span>        
          </div>
          <hr/>
        </div>
        <fieldset class="border-bottom">
          <label for="status">{{$t('status')}}</label>
          <span class="red">*</span>
          <div class="form-group">
            <div class="row">
              <div class="col-6 col-md-4 col-lg-3 col-xl-2">  
                <select id="status" class="form-control" name="container_training_agreement[status]" v-model="containerTrainingAgreement.status">
                  <option value="active">{{$t('active')}}</option>
                  <option value="inactive">{{$t('inactive')}}</option>
                </select>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset class="border-bottom">
          <legend>{{$t('set_primary')}}</legend>
          <p>{{$t('set_primary_guiding_text')}}</p>
  
          <div class="form-check">
            <input class="form-check-input" id="primary" type="radio" v-model="containerTrainingAgreement.primary" name="container_training_agreement[primary]" @change="onChangePrimary($event)" :value='primaryChecked' />
            <label for="primary" class="form-check-label">
              {{$t('primary')}}
            </label>
          </div>
        </fieldset>
        <fieldset class="border-bottom">
          <legend>{{$t('agreement_hours')}}</legend>
          <p>{{$t('hours_to_work_guiding_text')}}</p>
          <div class="form-group form-inline row align-items-start">
            <label class="col-sm-12 col-md-5 col-lg-4 justify-content-start d-inline" for="total_required_hours">
              {{$t('hours_to_work')}}
              <span class="red">*</span>
            </label>
            <Field
              :name="$t('hours_to_work')" 
              :rules="{required: true, between: [0, 1000000]}"
              v-slot="{ errors, field }"
              v-model="containerTrainingAgreement.total_required_hours">
              <input
                :class="{'is-invalid': errors[0]}"
                class="form-control" 
                inputId="total_required_hours"
                name="container_training_agreement[total_required_hours]"
                :label="$t('hours_to_work')"
                v-bind="field"
                className="col-sm-12 col-md-5 col-lg-3"
                type="number"
                step="0.01" />  
              <div class="invalid-feedback" :id="`${$t('hours_to_work')}_error`" v-if="errors[0]">
                <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                <span>{{ errors[0] }}</span>  
              </div>
            </Field>  
          </div>
          <p>{{$t('work_credit_hours_guiding_text')}}</p>
          <div class="form-group form-inline row align-items-start">
            <label for="work_credit_hours" class="col-sm-12 col-md-5 col-lg-4 justify-content-start d-inline">
              {{$t('work_credit_hours')}}
              <span class="red">*</span>
            </label>
            <Field
              :name="$t('work_credit_hours')" 
              :rules="{required: true, between: [0, 1000000]}"
              v-slot="{ errors, field }"
              v-model="containerTrainingAgreement.work_credit_hours">
              <input
                :class="{'is-invalid': errors[0]}"
                class="form-control" 
                inputId="work_credit_hours"
                name="container_training_agreement[work_credit_hours]"
                :label="$t('work_credit_hours')"
                v-bind="field"
                className="col-sm-12 col-md-5 col-lg-3"
                type="number"
                step="0.01" />  
              <div class="invalid-feedback" :id="`${$t('work_credit_hours')}_error`" v-if="errors[0]">
                <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                <span>{{ errors[0] }}</span> 
              </div>
            </Field>  
          </div>
          <p>{{$t('education_credit_hours_guiding_text')}}</p>
          <div class="form-group form-inline row align-items-start">
            <label for="education_credit_hours" class="col-sm-12 col-md-5 col-lg-4 justify-content-start d-inline">
              {{$t('education_credit_hours')}}
              <span class="red">*</span>
            </label>
            <Field
              :name="$t('education_credit_hours')" 
              :rules="{required: true, between: [0, 1000000]}"
              v-slot="{ errors, field }"
              v-model="containerTrainingAgreement.education_credit_hours">
              <input
                :class="{'is-invalid': errors[0]}"
                class="form-control " 
                inputId="education_credit_hours"
                name="container_training_agreement[education_credit_hours]"
                :label="$t('education_credit_hours')"
                v-bind="field"
                className="col-sm-12 col-md-5 col-lg-3"
                type="number"
                step="0.01"/> 
              <div class="invalid-feedback" :id="`${$t('education_credit_hours')}_error`" v-if="errors[0]">
                <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                <span>{{ errors[0] }}</span> 
              </div>
            </Field>
          </div>
        </fieldset>
        <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
          <span class="red mr-2">
            <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
          </span>
          {{ $t('error_warning') }}
        </div>
        <div class="btn-row d-flex">
          <button type="submit" v-if="containerTrainingAgreement.primary" :data-confirm="$t('primary_alert')" class="btn btn-success">
            <font-awesome-icon :icon="['fa', 'save']"/>
            {{ $t('create') }}
          </button>
          <button v-else type="submit" class="btn btn-success">
            <font-awesome-icon :icon="['fa', 'save']"/>
            {{ $t('create') }}
          </button>
          <a :href="container_training_agreements_path" class="btn btn-light ml-auto">
            <font-awesome-icon :icon="['fa', 'times']"/>
            {{ $t('cancel') }}
          </a>
        </div>
      </fieldset>
    </Form>

  </div>
</template>
<script>
import flash from '../../../shared/flash_messages/components/Flash.vue';
import NumberInput from '../../../shared/inputs/NumberInput.vue';
import '../../../../javascripts/application/vee-validate-rules';
import { sendAjaxRequest } from '../../../shared/typescripts/ajax.ts';
import { Form, Field } from 'vee-validate'
import { setErrorMessage } from '../../../shared/typescripts/error.ts'
import { formatDate } from '../../../shared/typescripts/dates.ts'

export default {
  components: { flash, NumberInput, Form, Field },

  props: ['container_training_agreement', 'container_training_agreements_path','container_name', 'training_agreements_path', 'method', 'submit_agreement_path'],
  
  data() {
    return {
      dropDownAgreements: [],
      trainingAgreement: null,
      containerTrainingAgreement: {
        training_agreement_id: 0,
        status: 'active',
        primary: false,
        total_required_hours: 0,
        work_credit_hours: 0,
        education_credit_hours: 0,
        confirmed_hours: 0,
        created_at: new Date(),
      },
      message_text: [],
      message_type: "",
      primaryChecked: null,
      csrfToken: $("meta[name='csrf-token']").attr("content"),
      showErrorBanner: false,
      loading: false
    }
  },
  mounted() {
    if(this.method === 'edit') {
      try {
        this.containerTrainingAgreement = JSON.parse(this.container_training_agreement)

      }
      catch {
        console.log("Invalid data")
      }
    }
   if (this.containerTrainingAgreement.primary == true) {
 
    this.primaryChecked = true
   }
  },
  methods: {
    // Submits the CTA either as an entirely new agreement or an update to an existing one
    submitCTA() {
      this.messageText = [];
      if(this.method === 'new' && this.trainingAgreement) {
        this.containerTrainingAgreement.training_agreement_id = this.trainingAgreement
      }

      let type = this.method === 'new' ? 'POST' : 'PUT'
      sendAjaxRequest(type, this.submit_agreement_path, 'json',  {container_training_agreement: this.containerTrainingAgreement}, this.ajaxSuccess, this.ajaxError);
    },

    ajaxError(message) {
        this.message_type = "error";
        this.message_text.push(message.responseText)
      },

    ajaxSuccess(response) {
          if(response.error){
            const errorArray = Object.values(response);
            this.message_type = "error";
            this.message_text =   errorArray
          }
          else {
            window.location.replace(response.path);
          }
      },
    onChangePrimary() {
      this.containerTrainingAgreement.primary = true
    },
    onTextEntry(search) {           
      this.loading = true
      const _vm = this;
      let data = {q: search}
      // Three characters is long enough to limit search time so we aren't searching for single or double characters
      // which could produce thousands of results and take an exceptionally long time to run
      if(search.length >= 3) {
        sendAjaxRequest('GET', _vm.training_agreements_path, 'json', data, this.textEntrySuccess);
      }
      this.dropDownAgreements = []
      this.loading=false
    },
    textEntrySuccess(data) {
      this.dropDownAgreements = []
      data.forEach((agreement) => {
        this.dropDownAgreements.push({value: agreement.id, label: agreement.label})
      })
      this.loading = false;
    },
    
    formatDate(dateString) {
      return formatDate(dateString)
    },

    setErrorMessage({ valuese, errors, results }) {
      setErrorMessage(this, errors, true)
    }
  }
}
</script>
